import React, { useState, useContext } from 'react';
import uuid from 'uuid-random';
import { StyledButton, StyledIconButton, StyledIcon } from '../../../Styled/StyledButtons';
import { VerbsButtonWrapper } from '../../../Styled/StyledWrappers';
import { insertDraggableElement } from '../../../DraggableLabel/ContextDraggableLabel';
import { WordsPageContext } from '../../../../contexts/wordsPageContext';
import { EditToolContext } from '../../../../contexts/editToolContext';
import { ILabel } from '../../../../types';
import { VerbsArrow } from '../../../../assets/icons/Arrows';

export const Verbs = (props: { labels: Array<ILabel>; isDisabled: boolean }): JSX.Element => {
  const { labels, isDisabled } = props;

  const { state, setLabels, saveLabelsUpdates } = useContext(WordsPageContext);
  const { isEditMode } = useContext(EditToolContext);

  const [isActive, setActive] = useState(false);

  const even = (element: ILabel) => element.position === undefined;

  const isVisible = labels.some(even);

  const handleClick = () => {
    setActive(!isActive);
  };

  const addLabel = (text: string) => {
    insertDraggableElement(state.labels, setLabels, saveLabelsUpdates, text, isEditMode);
  };

  const icon = isActive && !isDisabled ? <VerbsArrow side="left" /> : <VerbsArrow side="right" />;

  return (
    <VerbsButtonWrapper>
      <StyledIconButton
        data-testid="verbs-btn"
        aria-expanded={isActive && !isDisabled}
        type="button"
        onClick={handleClick}
        isActive={isActive && !isDisabled}
        disabled={!isVisible}
        isClickable={!isDisabled}
      >
        <span>Verbs</span>
        {icon}
      </StyledIconButton>
      {isActive && !isDisabled ? (
        <>
          {labels
            .filter(label => !label.position)
            .map(({ text }) => (
              <StyledButton key={uuid()} aria-label={text} onClick={() => addLabel(text)} data-testid="verbs-label">
                <span>{text}</span>
              </StyledButton>
            ))}
          {
            <StyledIcon aria-expanded={isActive && !isDisabled} type="button" onClick={handleClick}>
              {icon}
            </StyledIcon>
          }
        </>
      ) : null}
    </VerbsButtonWrapper>
  );
};
